
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/integration",
      function () {
        return require("private-next-pages/partners/integration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/integration"])
      });
    }
  